<script>
import Header from "../components/header/Header.svelte";
import TopbarSignedIn from "../components/TopbarSignedIn.svelte";
import Modals from "../components/Modals.svelte";
import Footer from "../components/Footer.svelte";

let complaint = {
  company: "DALOC AB",
  address: "Industrigatan 7",
  postal: "545 31 Töreboda",
};
</script>

<div class="container" id="wrapper">
  <TopbarSignedIn />
  <Header />
  <div class="complaint-four">
    <div class="row">
      <div class="col-xs-12">
        <div class="row fill-white">
          <div class="col-xs-12">
            <div id="content" class="main-content">
              <!-- contenttop -->
              <div class="row">
                <div class="col-xs-12">
                  <ul class="breadcrumb">
                    <li class="active">Min sida</li>
                    <li>
                      <a href="/shop/IboxServlet?p=IXS850">Reklamationer</a>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- Workflow -->
              <div class="workflow">
                <ul class="breadcrumb breadcrumb-secondary mt-md">
                  <li><a href="#"><span>1. Ärende</span></a></li>
                  <li><a href="#"><span>2. Rader</span></a></li>
                  <li><a href="#"><span>3. Anmärkningar</span></a></li>
                  <li class="active-step"><span>4. Leveransadress</span></li>
                  <li><a href="#"><span>5. Boka</span></a></li>
                  <li><a href="#"><span>6. Kvitto</span></a></li>
                </ul>
              </div>
              <div class="clear"></div>

              <div class="row">
                <div class="col-xs-12">
                  <!-- Huvud -->
                  <form
                    class="full cart"
                    action="/shop/IboxServlet"
                    method="post"
                    accept-charset="utf-8"
                    name="form"
                    id="form"
                  >
                    <input type="hidden" name="p" value="IXS855" />
                    <input type="hidden" name="OPT" value="4" />

                    <div id="levval">
                      <div class="row">
                        <div class="col-xs-12 mt-sm">
                          <h2>Ny reklamation / retur</h2>
                        </div>
                      </div>

                      <div class="border-frame col-md-6">
                        <label>Leveransadress vid ersättningsleverans</label>
                        <select name="form_select">
                          <option value="001">
                            MAXIDOOR AB, NORRA BANGATAN 46, 718 32, FRÖVI
                          </option>
                          <option value="002">
                            RK´S GLASMONTAGE AB, NORSHOLM STENTORPA, 61021,
                            NORSHOLM
                          </option>
                          <option value="003">
                            FASADSYSTEM STÅL I BORÅS AB, HAGVÄGEN 3, 51634,
                            DALSJÖFORS
                          </option>
                          <option value="004">
                            Åhlin &amp; Ekeroth Byggnads Arb.plats, Vadstena
                            RPR, Jungfruvägen, Hans-Ola Telavi 070-301 68 47,
                            592 32, VADSTENA
                          </option>
                          <option value="MAN">Ange en annan adress</option>
                        </select>

                        <button
                          class="button btn btn-primary mt-md"
                          type="submit"
                        ><span>Nästa</span></button>
                      </div>
                      <div class="row">
                        <div class="delivery-address col-md-6 ml-sm">
                          <h4>Leveransadress</h4>
                          <p class="company-name">{complaint.company}</p>
                          <p>{complaint.address}</p>
                          <p>{complaint.postal}</p>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<Footer />
<Modals />
